/**
 * Endpoints OutboxEvents — ressource exploitation introduite en guide v2.5.
 *
 * 6 services exposent le même contrat :
 * - `GET /api/v1/OutboxEvents/all` (query `page`/`pageSize`)
 * - `POST /api/v1/OutboxEvents/{outboxEventId}/replay` (body `{ reason }`)
 *
 * Rôles : `flashpay-superadmin` / `flashpay-admin` côté wallet/admin/ledger/
 * merchant ; `aucun rôle particulier` côté kyc/fee-engine (fallback
 * `GatewayDefault`). Replay refusé si l'événement n'est pas en `DEAD_LETTER`
 * (422).
 */

/** Liste des services qui exposent le registre `OutboxEvents`. */
export const OUTBOX_SERVICES = [
  "admin",
  "fee-engine",
  "kyc",
  "ledger",
  "merchant",
  "wallet",
] as const;

export type OutboxService = (typeof OUTBOX_SERVICES)[number];

const basePath = (service: OutboxService) => `/gw/${service}/api/v1/OutboxEvents`;

export const outboxEndpoints = {
  /** GET — liste paginée. */
  all: (service: OutboxService) => `${basePath(service)}/all`,
  /** POST — rejoue un événement en DEAD_LETTER. Body `{ reason }`. */
  replay: (service: OutboxService, outboxEventId: string) =>
    `${basePath(service)}/${outboxEventId}/replay`,
} as const;
